"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--background-color, var(--smar--com--color--blue--100,#9ebbff))",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.4,
  d: "M10 6.03a7.3 7.3 0 0 0-7.232 6.302c-.075.547.38.997.932.997h1.823c.552 0 .985-.457 1.147-.985a3.35 3.35 0 0 1 3.189-2.37c1.5 0 2.769 1.003 3.188 2.37.163.528.596.985 1.148.985H16.3c.552 0 1.007-.45.933-.997A7.3 7.3 0 0 0 10 6.029"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m6.665 6.947 1.962 3.061-1.178.756-1.963-3.062zm4.708 3.061 1.963-3.061 1.178.755-1.962 3.062zm3.559.572a.7.7 0 0 0-.95-.279l-4.317 2.355a.7.7 0 1 0 .67 1.229l4.318-2.355a.7.7 0 0 0 .28-.95",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=MeterThreeIcon20.js.map